import { useRef, useEffect } from "react";
type TimeoutRef = ReturnType<typeof setTimeout> | null;

export const useTimeouts = () => {
  const timeoutRef = useRef<TimeoutRef>(null);

  const setTimeoutRef = (callback: () => void, delay: number) => {
    const timeoutId = setTimeout(callback, delay);
    timeoutRef.current = timeoutId;
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { setTimeoutRef };
};
